export const BROADCAST_CHANNEL_NAME = 'perfect_channel';

export enum BROADCAST_CHANNEL_MESSAGE_TYPE {
  LOGOUT = 'LOGOUT'
}
